import styled from 'styled-components';

export default styled.div`
    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: var(--spacing-24);

        .rules-modal-title {
            font-size: 1.25rem;
            font-weight: var(--font-weight-bold);
            line-height: var(--spacing-24);
            letter-spacing: 0.02em;
            text-align: left;
        }
    }

    .motd-rules {
        height: 34rem;
        overflow-y: auto;
        text-align: left;

        em {
            font-style: var(--font-10);
            color: var(--color-motd);
        }
    }

    .pointer {
        cursor: pointer;
    }
`;
